export default "__VITE_ASSET__DPgT_Yvf__"